import React from 'react';

const SectionContext = React.createContext({});

export const { Provider, Consumer } = SectionContext;
export default SectionContext;
